const lstDeveloper = ['Developer']
const lstAdministrator = ['Developer', 'Administrator']
const lstUser = ['Developer', 'Administrator', 'User']
const lstReader = ['Developer', 'Administrator', 'User', 'Reader']

export default {
  name: 'PrivilegeMixin',
  computed: {
    privRole () {
      return this.$auth.user().userrole_name
    },
    privDeveloper () { return lstDeveloper.includes(this.privRole) },
    privAdministrator () { return lstAdministrator.includes(this.privRole) },
    privUser () { return lstUser.includes(this.privRole) },
    privReader () { return lstReader.includes(this.privRole) }
  }
}



// WEBPACK FOOTER //
// ./src/components/PrivilegeMixin.js